import { CmsSchema, useCmsFields } from '@/cms/content';
import { displayText } from '@/lib/displayText';

/** A fixed text slot. Its surrounding layout and links remain owned by the page. */
export function CmsEditorialText({
  id,
  value,
  label,
  section = 'Treść strony',
  multiline = false,
  optionalMarker = false,
}: {
  id: string;
  value: string;
  label: string;
  section?: string;
  multiline?: boolean;
  optionalMarker?: boolean;
}) {
  const cms = useCmsFields([{
    key: id,
    label,
    section,
    kind: multiline ? 'textarea' : 'text',
    defaultValue: value,
    required: true,
    optionalMarker,
  }]);
  return <><CmsSchema fields={cms.fields} /><span {...cms.text(id)}>{displayText(cms.value(id))}</span></>;
}
